import {downloadFormResponsePdfReport} from '../../../../../api/services/filesService';

// Maria, 18 October 2026: 'Download' and 'Print' on a form in a profile use the form's PDF
export const fetchPdfUrl = async (formId, formRequestId) => {
    const res = await downloadFormResponsePdfReport({formId, formRequestId});
    return res?.blob ? URL.createObjectURL(new Blob([res.blob], {type: 'application/pdf'})) : null;
};

export const downloadPdf = async (formId, formRequestId, fileName) => {
    const url = await fetchPdfUrl(formId, formRequestId);
    if (!url) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName ?? 'Form'}.pdf`;
    link.click();
    setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const printPdf = async (formId, formRequestId) => {
    const url = await fetchPdfUrl(formId, formRequestId);
    if (!url) return;
    const frame = document.createElement('iframe');
    frame.style.position = 'fixed';
    frame.style.width = '0';
    frame.style.height = '0';
    frame.style.border = '0';
    frame.src = url;
    frame.onload = () => {
        frame.contentWindow.focus();
        frame.contentWindow.print();
        setTimeout(() => {
            frame.remove();
            URL.revokeObjectURL(url);
        }, 60000);
    };
    document.body.appendChild(frame);
};
